import React from 'react';

import { className, Text, Heading, ImageComponent } from 'aplazame-design-system';
import TransitionLink from 'aplazame-design-system/src/components/TransitionLink';

import style from './style.module.scss';
import colorStyle from 'aplazame-design-system/src/scss/color.module.scss';


export default function CardCollectionComponent({
    title,
    slug,
    image,
    productsNrText,
    updatedText
}) {
    return (
        <>
            <TransitionLink
                to={`/${slug}/`}
                {...className([
                    style['image-wrapper'],
                    'mb-3'
                ].join(' '))}
                aria-label={title}
            >
                {image ? (
                    <ImageComponent
                        image={image}
                        alt={title}
                        className={style.image}
                    />
                ) : (
                    <div className={style['image-placeholder']} />
                )}
            </TransitionLink>
            <Text
                className={`h4 ${colorStyle['color--primary']} d-block mb-1 ${style.date}`}
                tag="span"
            >{updatedText}</Text>
            <TransitionLink
                to={`/${slug}/`}
                title={title}
            >
                <Heading
                    className={`mb-1 ${style.heading}`}
                    tag="h2"
                >{title}</Heading>
            </TransitionLink>
            <Text
                className={`d-block ${style.quantity}`}
                tag="span"
            >{productsNrText}</Text>
        </>
    );
}